import React, { useEffect, useState, useRef } from "react";

const Privacy: React.FC = () => {
    return (
        <div
            className="container"
            style={{
                fontFamily: "Noto Sans",
            }}
        >
            <div>
                <h1
                    style={{
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    Privacy Policy
                </h1>
                <p>
                    ReThink Travel ("ReThink," “Re”, “Portal”, “Platform”,
                    “Company”, "we," “GetRe”, "us," or "our") is committed to
                    protecting your privacy. This Privacy Policy explains how we
                    collect, use, store, and disclose your personal information
                    when you use our website, platform, tools, or services. By
                    using our Services, you consent to the practices described
                    in this policy.
                </p>
                <p>
                    By using the ReThink’s Services, the User agrees that the
                    Portal can use such data in accordance with the Portal’s
                    privacy policy. The Portal uses a variety of security,
                    electronic, and managerial procedures to help protect all
                    the information from unauthorised access, use or disclosure.
                    Only authorised employees within ReThink Travel who, in the
                    course of their duties, can access and use information
                    collected from individual users. To correct factual errors
                    in your personally identifiable information, contact us at
                    rethink@getre.org. We may request additional verification
                    and will respond within 30 days. To protect privacy and
                    security, Portal will also take reasonable steps to verify
                    their identity before making corrections. The Portal uses
                    the information acquired to understand and analyse the usage
                    trends and preferences of the Users, visitors and end users,
                    to improve the Service, and to develop new products, tools,
                    services, features, and functionality. The data will be used
                    in aggregated form. User data will be used for marketing,
                    sales, and promotional purposes. The Portal constantly
                    reviews the systems and data to ensure the best possible
                    service to the Users. In case, the Government authorities
                    require data for any purpose, the Portal will have to
                    provide them with the same. Like most interactive platforms,
                    this Portal uses cookies and other trackers to enable the
                    Portal to retrieve user details.
                </p>
                <h1>Information We Collect</h1>
                <p>
                    Personal Information: We may collect the following personal
                    data:
                    <ul>
                        <li>Full name</li>
                        <li>Email address</li>
                        <li>Phone number (WhatsApp)</li>
                        <li>
                            Location information (for travel carbon calculation)
                        </li>
                        <li>Other information</li>
                        <li>
                            Payment information (processed via third-party
                            gateways)
                        </li>
                    </ul>
                </p>
                <p>
                    Non-Personal Information: We may collect aggregated,
                    anonymized data such as:
                    <ul>
                        <li>Browser type</li>
                        <li>Device information</li>
                        <li>IP address</li>
                        <li>Pages visited</li>
                        <li>Time spent on the platform</li>
                        <li>Other information</li>
                    </ul>
                </p>
                <p>
                    Aggregated, anonymized data will be used to analyze trends
                    and improve services. This data does not identify
                    individuals.
                </p>
                <h1>How We Use Your Information</h1>
                <p>
                    We use the information we collect to:
                    <ul>
                        <li>Provide and operate our Services</li>
                        <li>Calculate travel-related carbon emissions</li>
                        <li>Process payments and contributions</li>
                        <li>
                            Communicate project updates and confirmation on
                            WhatsApp or emails
                        </li>
                        <li>Improve the user experience</li>
                        <li>
                            Sharing it with third-party for marketing purposes
                        </li>
                        <li>Send newsletters and sustainability education</li>
                    </ul>
                </p>
                <h1>Sharing and Disclosure</h1>
                <p>
                    We may share your data with:
                    <ul>
                        <li>
                            Third-party payment gateways for transaction
                            processing
                        </li>
                        <li>
                            Project partners for implementation verification
                            (anonymized)
                        </li>
                        <li>Third-party companies for marketing</li>
                        <li>
                            Legal authorities when required under applicable law
                        </li>
                    </ul>
                </p>
                <h1>Data Retention</h1>
                <p>
                    We retain personal information only as long as necessary for
                    legitimate business purposes and to comply with legal
                    obligations. Non-personal information may be retained
                    indefinitely.
                </p>
                <h1>Cookies and Tracking Technologies</h1>
                <p>
                    We use cookies to:
                    <ul>
                        <li>Improve website functionality</li>
                        <li>Understand user behavior</li>
                        <li>Track impact and engagement metrics</li>
                    </ul>
                </p>
                <p>
                    You may disable cookies through your browser settings, but
                    doing so may impact your experience.
                </p>
                <p>
                    We may use third-party services such as Google Analytics,
                    Meta Pixel, or other analytics tools to better understand
                    user behavior, measure engagement, and improve our Services.
                    These tools may use cookies and similar technologies to
                    collect non-personal information such as your IP address,
                    browser type, and pages visited.
                </p>
                <p>
                    By using our platform, you consent to the placement of
                    cookies and the use of these technologies unless you disable
                    them via your browser settings.
                </p>
                <h1>Data Security</h1>
                <p>
                    We implement appropriate technical and organizational
                    measures to protect your personal data against unauthorized
                    access, loss, or alteration. However, no system is entirely
                    secure, and we cannot guarantee absolute data security.
                </p>
                <h1>Third-Party Links</h1>
                <p>
                    Our platform may contain links to external websites. We are
                    not responsible for the content or privacy practices of such
                    websites. Please review their privacy policies
                    independently.
                </p>
                <h1>Your Rights</h1>
                <p>
                    Subject to applicable laws, you have the right to:
                    <ul>
                        <li>Access and obtain a copy of your personal data</li>
                        <li>Request correction of inaccurate data</li>
                        <li>Withdraw consent (where applicable)</li>
                        <li>Request deletion of your data</li>
                    </ul>
                </p>
                <p>To exercise these rights, contact us at rethink@getre.org</p>
                <h1>Children's Privacy</h1>
                <p>
                    Our Services are not intended for children under the age of
                    13. We do not knowingly collect data from minors. If you
                    believe a child has provided us personal data, please
                    contact us.
                </p>
                <h1>International Users</h1>
                <p>
                    If you are accessing our Services from outside India, you
                    agree that your data may be transferred to and processed in
                    India or another country where data protection laws may
                    differ from your jurisdiction.
                </p>
                <p>
                    If you are accessing our Services from regions with laws
                    governing data collection and use, including but not limited
                    to the European Union (under the General Data Protection
                    Regulation or "GDPR"), please be aware that ReThink Travel
                    does not currently claim full compliance with the GDPR or
                    equivalent international frameworks. By using our Services
                    and submitting your personal data, you consent to this
                    transfer and acknowledge that your information will be
                    handled in accordance with this Privacy Policy.
                </p>
                <p>
                    By providing your personal data, you consent to any such
                    transfer and processing in accordance with this Privacy
                    Policy.
                </p>
                <p>
                    While we aim to handle your data with care and strive to
                    incorporate best practices aligned with internationally
                    accepted data protection standards, it is your
                    responsibility to assess whether our practices meet your
                    local legal requirements.
                </p>
                <h1>Changes to This Policy</h1>
                <p>
                    We may update this Privacy Policy periodically. Changes will
                    be posted on this page with an updated revision date. Your
                    continued use of the Services indicates acceptance of the
                    revised policy.
                </p>
                <h1>Contact Us</h1>
                <p>
                    For any questions or concerns regarding this Privacy Policy
                    or your data, please contact: Email: rethink@getre.org.
                </p>
            </div>
        </div>
    );
};

export default Privacy;
